import React from 'react';
//import { BrowserRouter as Router, Route, Switch, NavLink } from 'react-router-dom';
import AdminProCatCreate from './AdminProCatCreate';
import AdminProSubCatCreate from './AdminProSubCatCreate';
import AdminProProductCreate from './AdminProProductCreate';

export default class AdminProCreate extends React.Component {
  componentDidMount() {
    
  }
  render() {
    //console.log('Render Pro Create: Props: ' + JSON.stringify(this.props));

    return (
      <div>
            <ul className="nav nav-pills mb-3" id="pills-tabC" role="tablist">
                <li className="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Select Type</a>
                  <div class="dropdown-menu">
                    <a class="dropdown-item" id="pills-category-tab" data-toggle="pill" href="#pills-category" role="tab" aria-controls="pills-category" aria-selected="false">Category</a>
                    <a class="dropdown-item" id="pills-subcat-tab" data-toggle="pill" href="#pills-subcat" role="tab" aria-controls="pills-subcat" aria-selected="false">Sub Category</a>
                    <a class="dropdown-item" id="pills-product-tab" data-toggle="pill" href="#pills-product" role="tab" aria-controls="pills-product" aria-selected="false">Product</a>
                  </div>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabCContent">
                <div className="tab-pane fade" id="pills-category" role="tabpanel" aria-labelledby="pills-category-tab"><AdminProCatCreate/></div>
                <div className="tab-pane fade" id="pills-subcat" role="tabpanel" aria-labelledby="pills-subcat-tab"><AdminProSubCatCreate categories={this.props.categories}/></div>
                <div className="tab-pane fade" id="pills-product" role="tabpanel" aria-labelledby="pills-product-tab"><AdminProProductCreate {...this.props}/></div>
            </div>
      </div>
    )
    }
  };